<p>missing-configuration-job works!</p>
